import React, { useState, useRef } from "react";
import searchIcon from "..//assets/res/search_black.svg";

function SearchBar({ querySearched, onFocusSearch }) {
  const [query, setQuery] = useState("");

  const inputRef = useRef(null);


  return (
    <div className="mt-[16px] mx-[32px] rounded-xl width-[300px] bg-white shadow-lg flex flex-row items-center rounded-md border rounded-xl medium border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-300">
      <div className="h-6 w-6  ml-4">
        <img src={searchIcon} className="h-6 w-6"></img>
      </div>
      <input
        type="text"
        placeholder="Search game/app/mod"
        className="w-full p-2  rounded-xl medium border-gray-300 focus:outline-none "
        value={query}
        onFocus={() => {
          onFocusSearch(true)
        }}
        onChange={(e) => {
          setQuery(e.target.value);
          querySearched(e.target.value);
        }}
      />
    </div>
  );
}

export default SearchBar;
